/** Name of the feature. */
export const StandardEvents = 'standard:events';
/**
 * @deprecated Use {@link StandardEvents} instead.
 *
 * @group Deprecated
 */
export const Events = StandardEvents;
//# sourceMappingURL=events.js.map